import { createStore } from "zustand";

export interface IAppBarState {
    activeBg: boolean;
}

export const defaultAppBarState: IAppBarState = { activeBg: false };

const appBarState = createStore<IAppBarState>(() => defaultAppBarState);

export default appBarState;
